const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		staticLookupName: 'ttgShopController'
	},

	methods: {
		showEdit: function(type, entityID, resourceRegister){
			var self = this;
			var baseActionKey = 'showEdit_' + (type || '');

			return self.performAndStoreAction(
				`${baseActionKey}_inEffect`,
				self.prepareAction(baseActionKey, entityID, {
					componentDefinition: utils.simpleCopy(self.resourceData || {})
				}),
				true
			);
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
							if(modalContentComponent && modalContentComponent.hasClass('base_form_form')){
								await modalContentComponent.submit()
								await options.decisionComponent.hide()
							}
							break
					}
					break

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break
					}
					break

				default:
					// TODO: ERROR;
					break
			}
		},
	}
}
